import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';
import router from './routes';
import store from './Store/store';
import vuelidate from 'vuelidate';
import wysiwyg from 'vue-wysiwyg';
import SlugInput from 'vue-slug-input';

import Button from './components/UI/button.vue';
Vue.component('app-button', Button);

/* FONT-AWSOME */
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSignOutAlt,faSignInAlt,faFileAlt,faEye,faStar} from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faFacebookSquare, faTwitter, faLinkedin, faWhatsapp, faTumblr, faPinterest, faVk } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faSignOutAlt,faSignInAlt,faFileAlt,faEye,faStar,faFacebookSquare,faTwitter,faLinkedin,faWhatsapp,faTumblr,faPinterest,faVk,faEnvelope)

Vue.component('font-awesome-icon', FontAwesomeIcon)

/* RESOURCE */
Vue.use(VueResource);
Vue.http.options.root = 'https://gamespot-21f84.firebaseio.com/';

/* MIC */
Vue.use(vuelidate);
Vue.use(wysiwyg);
Vue.use(SlugInput);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
